import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: '[breadcrumb]',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {

  @Input()
  width: number;

  @Input()
  color: string;

  @Input()
  label: string;

  private _left: number;
  private _height: number;
  private _isFirst: boolean;
  private _isLast: boolean;
  private _path: string;

  set left(left: number) {
    this._left = left;
    this.updatePath();
  }

  set height(height: number) {
    this._height = height;
    this.updatePath();
  }

  set isFirst(isFirst: boolean) {
    this._isFirst = isFirst;
    this.updatePath();
  }

  set isLast(isLast: boolean) {
    this._isLast = isLast;
    this.updatePath();
  }

  set path(path: string) {
    this._path = path;
  }

  get path() {
    return this._path;
  }

  get height() {
      return this._height;
  }

  get totalWidth() {
    // return height because each end cap is height/2 wide
    return this._isFirst ? this._height + this.width : this._height / 2 + this.width;
  }

  get textLeft() {
    return this._isFirst ? this._left + this._height / 2 + this.width / 2 : this._left + this.width / 2;
  }

  updatePath() {
    let halfHeight = this._height / 2;
    let newPath = this._isFirst
      // The first piece considers the rounded edge of the arc to be at x=0
      ? `M ${this._left + halfHeight}, 0.0 `
      // Subsequent pieces consider the label section to be at x=0, with the arror "tail" at x=-halfHeight
      : `M ${this._left}, 0.0 `;

    // The top of the label section is "width" long
    newPath += `h ${this.width} `;

    newPath += this._isLast
      // The last piece ends with an arc
      ? `a ${halfHeight}, ${halfHeight}, 0, 0, 1, 0.0, ${this._height} `
      // Previous pieces end with an arrow "head"
      : `l ${halfHeight}, ${halfHeight} l ${-halfHeight}, ${halfHeight} `;

    // The bottom of the label section is "width" long
    newPath += `h ${-this.width} `;

    newPath += this._isFirst
      // The first piece starts with an arc at x = 0
      ? `a ${halfHeight}, ${halfHeight}, 0, 0, 1, 0.0, ${-this._height}`
      // Subsequent pieces start with an arrow "tail" that goes left of x=0 to "fit" into the previous arrow "head"
      : `h ${-halfHeight} l ${halfHeight}, ${-halfHeight} l ${-halfHeight}, ${-halfHeight} h ${halfHeight}`;

    this.path = newPath;
  }
}
